
















import Vue from 'vue';
import sortByTitle from '@/tools/helpers/sortByTitle';
import ApiRequest from '@/tools/ApiRequest';
import formValidationRules from '@/tools/validationRules/formValidationRules';
import RequestException from '@/tools/helpers/RequestException';

export default Vue.extend({
  name: 'DistributorAutocomplete',
  data: () => ({
    validationRules: formValidationRules,
    selectedDistributorId: -1,
    distributors: [] as { id: number; title: string }[],
  }),
  methods: {
    getDistributorFromApi(): void {
      ApiRequest.getDistributors()
        .then((response) => {
          this.distributors = response.data;

          sortByTitle(this.distributors);
        })
        .catch((error) => new RequestException(error, this.$store, this.$router));
    },
    getSelectedDistributor(): number {
      return this.selectedDistributorId;
    },
  },
  created(): void {
    this.getDistributorFromApi();
  },
});
